var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('section',[_c('h1',{staticClass:"blue"},[_vm._v("404")]),_vm._m(0),_c('h1',{staticClass:"blue"},[_vm._v(":(")]),_c('h1',[_vm._v("Suche doch hier weiter")]),_c('router-link',{attrs:{"to":"/home"}},[_c('button',[_vm._v("Suchen")])])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_vm._v("Seite konnte nicht"),_c('br'),_vm._v("gefunden werden")])
}]

export { render, staticRenderFns }